import { defineComponent, ref, computed, watch } from 'vue';
import ChevronIconDown from '../../../assets/icons/chevron-down.svg.js';
import __vue_component__ from '../../layout/InfoSubtitle.vue.js';
import __vue_component__$1 from '../../layout/InfoTitle.vue.js';
import TransitionExpand from '../../transitions/TransitionExpand/TransitionExpand.js';

var script = defineComponent({
    name: 'ExpandableComponent',
    components: {
        ChevronIconDown,
        InfoSubtitle: __vue_component__,
        InfoTitle: __vue_component__$1,
        TransitionExpand,
    },
    model: {
        prop: 'isExpanded',
        event: 'expanded',
    },
    props: {
        // The model value
        isExpanded: {
            type: Boolean,
            default: undefined,
        },
        disabled: Boolean,
        // Like disabled, but doesn't override initialIsOpened
        altDisabled: Boolean,
        title: {
            type: String,
            required: true,
        },
        subtitle: {
            type: String,
            default: null,
        },
        altButtonStyle: Boolean,
        initialIsOpened: Boolean,
        group: Boolean,
        hideHeaderSection: Boolean,
    },
    setup(props, { emit, expose }) {
        const getInitialState = () => {
            if (props.disabled)
                return false;
            if (props.isExpanded !== undefined)
                return props.isExpanded;
            return props.initialIsOpened;
        };
        const isOpened = ref(getInitialState());
        const setOpenedState = (state) => {
            if (props.disabled || props.altDisabled)
                return;
            isOpened.value = state;
            emit('expanded', isOpened.value);
        };
        const titleSectionClassNames = computed(() => {
            const names = [];
            if (!props.disabled && !props.altDisabled)
                names.push('is-clickable');
            if (isOpened.value)
                names.push('ExpandableComponent__title--open');
            return names;
        });
        const buttonClassNames = computed(() => {
            const names = ['ExpandableComponent__button'];
            if (isOpened.value)
                names.push('ExpandableComponent__button--open');
            if (props.disabled)
                names.push('ExpandableComponent__button--disabled');
            if (props.altButtonStyle)
                names.push('ExpandableComponent__button--alt-button-style');
            return names;
        });
        const minimize = () => {
            setOpenedState(false);
        };
        expose({
            minimize,
        });
        watch(() => props.isExpanded, (next) => {
            if (next !== undefined)
                isOpened.value = next;
        }, { immediate: true });
        return {
            buttonClassNames,
            isOpened,
            setOpenedState,
            titleSectionClassNames,
        };
    },
});

export { script as default };
